import React from 'react';

import { SnackbarContext, SnackbarActions } from '@contexts/index';
import type { SnackbarVariant } from '@contexts/snackbar';

export function useSnackbar() {
  const context = React.useContext(SnackbarContext);

  // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
  if (context === undefined) {
    throw new Error(`useSnackbar must be used within a SnackbarProvider`);
  }

  const { state, dispatch } = context;

  const enqueueSnackbar = React.useCallback(
    ({
      message,
      variant = 'info',
      isPersistent = false,
    }: {
      message: React.ReactNode;
      variant?: SnackbarVariant;
      isPersistent?: boolean;
    }) => {
      dispatch({
        type: SnackbarActions.Enqueue,
        message,
        variant,
        isPersistent,
      });
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []
  );

  const dequeueSnackbar = React.useCallback(
    (id: number) => {
      dispatch({ type: SnackbarActions.Dequeue, id });
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []
  );

  return { state, dispatch, enqueueSnackbar, dequeueSnackbar };
}
